(function () {
  class FireballIntro extends PIXI.Container {
    constructor() {
      super();

      this._callback = undefined;
      this.visible = false;

      this._pressStartBox = undefined;

      this._baseName = "";
      this._anims = [];
    }

    ///////////////////////////////////////////////
    initialise() {
      const self = this;

      messageBus.subscribe("spinner:GameConfigEvent", function () {
        self.onLayoutComplete();
      });
    }

    ///////////////////////////////////////////////
    onLayoutComplete() {
      this._baseName = "slotContainer:fireballIntroPopup:fireballIntro";
      this._pressStartBox = resourceManager.get(
        this._baseName + ":pressStartColourBox"
      );

      this._pressStartBox.alpha = 0;
      this._pressStartBox.visible = false;
      this._pressStartBox.interactive = false;

      for (let i = 0; i < 4; i++) {
        let anim = resourceManager.get(
          this._baseName + ":frameLightningAnim" + i
        );
        anim.gotoAndStop(0);
        anim.visible = false;

        this._anims.push(anim);
      }
    }

    ///////////////////////////////////////////////
    setup() {
      resourceManager.get(this._baseName).visible = true;

      // wait for click - anywhere on screen
      this._pressStartBox.visible = true;
      this._pressStartBox.alpha = 0;
      this._pressStartBox.interactive = true;
      this._pressStartBox.mousedown = this._pressStartBox.touchstart =
        this.closeDialog.bind(this);
    }

    ///////////////////////////////////////////////
    showIntro(callback) {
      this.setup();
      this._callback = callback;

      resourceManager.get("fireballLinkIntroDim").visible = true;

      for (let i = 0; i < 4; i++) {
        const anim = this._anims[i];
        anim.gotoAndPlay(0);
        anim.visible = true;
        anim.onComplete = function () {
          anim.visible = false;
        };
      }

      gameData.musicManager.fadeOutAllMusic();
      gameData.musicManager.fadeInPopUpMusic();
      soundManager.play("bonusWon");
    }

    ///////////////////////////////////////////////
    closeDialog() {
      gameData.musicManager.fadeOutPopUpMusic();

      // turn off click processing
      this._pressStartBox.visible = false;
      this._pressStartBox.alpha = 0;
      this._pressStartBox.interactive = false;
      this._pressStartBox.mousedown = this._pressStartBox.touchstart =
        undefined;

      gameData.musicManager.fadeLevels(0, "stormLink");

      resourceManager.get(this._baseName).visible = false;
      resourceManager.get("fireballLinkIntroDim").visible = false;
      this._callback();
    }
  }

  ///////////////////////////////////////////////
  let fireballIntroCreator = function (json) {
    return new FireballIntro();
  };

  ///////////////////////////////////////////////
  let fireballIntroInitialiser = function (json, disclaimer) {
    disclaimer.initialise();
  };

  ///////////////////////////////////////////////
  let fireballIntroFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "FireballIntro",
    fireballIntroCreator,
    fireballIntroInitialiser,
    fireballIntroFilesRequired
  );
})();
